<template>
  <a-card>
    <a-form layout="horizontal">
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-item
            label="姓名/学号"
            :labelCol="{ span: 5 }"
            :wrapperCol="{ span: 18, offset: 1 }"
          >
            <a-input placeholder="请输入" v-model="params.name" />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-button
            type="primary"
            style="margin-left: 8px; align: center; margin-top: 3px"
            @click="search"
            >查询</a-button
          >
        </a-col>
      </a-row>
    </a-form>
    <a-dropdown style="margin-bottom: 15px">
      <div slot="overlay" class="overlay">
        <a-button
          type="link"
          size="small"
          style="margin-bottom: 10px"
          @click="uploadFileModal('del')"
          >上传删除人员名单</a-button
        >
        <a-divider style="margin-bottom: 10px" />
        <a-button type="link" size="small" @click="uploadFileModal('replace')"
          >替换毕业名单</a-button
        >
      </div>
      <a-button> 批量删除</a-button>
    </a-dropdown>
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="pagination"
      :rowKey="(row) => row.id"
    >
      <span slot="bed" slot-scope="row">
        {{ row.studentArea }} - {{ row.studentRoom }} -{{ row.studentBed }}
      </span>
      <span slot="action" slot-scope="row">
        <a-popconfirm
          title="确认删除吗?"
          ok-text="是"
          cancel-text="否"
          @confirm="del(row.id)"
        >
          <a-button type="link" size="small">删除</a-button>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="uploadModal" title="上传名单" @ok="submit">
      <ol>
        <li>
          <p>
            下载模板，并按照模板中的使用说明填写信息，<span style="color: red">
              请勿更改表结构（如删除某行）</span
            >
          </p>
          <p><a @click="downloadTemplateFile">下载《毕业名单导入模板》</a></p>
        </li>
        <li>
          <p>请选择填写完成的excel 文档</p>
          <a-form-model
            ref="uploadExcelRuleForm"
            :model="uploadFrom"
            :rules="uploadExcelRules"
          >
            <a-form-model-item
              :labelCol="{ span: 0 }"
              :wrapperCol="{ span: 24 }"
              prop="fileName"
            >
              <c-upload
                name="file"
                :multiple="false"
                :action="uploadFileUri"
                acceptType="excel"
                @change="handleChange"
              >
                <div v-if="uploadFrom.fileName">
                  <a-icon type="file-excel" />
                  <a v-text="uploadFrom.fileName"></a>
                </div>
                <a-button v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'" />选择文件
                </a-button>
              </c-upload>
            </a-form-model-item>
          </a-form-model>
          <p>请上传格式为xls或xlsx的文件，最大支持30M</p>
        </li>
      </ol>
    </a-modal>
  </a-card>
</template>

<script>
import {
  queryStudentByBatchId,
  deleteStudent,
  uploadDelStudent,
  uploadSaveStudent,
} from "@/services/graduationList";
import uploadFileUri from "@/services/uploadFileUri";
import downloadTemplateFile from "@/services/downloadTemplateFile";
const uploadExcelRules = {
  fileName: [{ required: true, message: "请选择文件", trigger: "change" }],
};

const columns = [
  {
    title: "学号",
    dataIndex: "studentCode",
  },
  {
    title: "姓名",
    dataIndex: "studentName",
  },

  {
    title: "学院",
    dataIndex: "studentCollegeName",
  },
  {
    title: "专业",
    dataIndex: "specialityName",
  },
  {
    title: "学历",
    dataIndex: "studentGraduateType",
  },
  {
    title: "入住床位",
    scopedSlots: { customRender: "bed" },
  },
  {
    title: "毕业类型",
    dataIndex: "studentGraduateType",
  },
  // {
  //   title: "身份证号",
  //   dataIndex: "studentIdcard",
  // },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
  },
];

const dataSource = [
  // {
  //   "id": "001b7cdc-3f95-43d5-9d49-122a89dc7516",
  //   "studentAcount": null,
  //   "studentCode": "2018010248",
  //   "studentName": "江宜泉",
  //   "studentMobile": null,
  //   "studentSex": null,
  //   "studentBirth": null,
  //   "remark": null,
  //   "status": 0,
  //   "updateTime": null,
  //   "batchId": "14f9d302-a848-4167-9f4a-8a345191a2f9",
  //   "studentCollege": "216",
  //   "studentClass": "海工18-2班",
  //   "studentBed": "2",
  //   "studentIdcard": null,
  //   "studentEducation": null,
  //   "studentGraduateType": "本科生",
  //   "studentSpeciality": "02008",
  //   "studentGrade": "2018",
  //   "studentTutor": null,
  //   "studentInstructor": "2015880031",
  //   "studentStatus": "01",
  //   "studentRoom": "3408",
  //   "studentFloor": "4层",
  //   "studentBuilding": "3号楼3门",
  //   "studentArea": "青年园公寓",
  //   "studentGraduationTime": "20220628",
  //   "oldId": null
  // },
  // {
  //   "id": "00572b74-9253-4945-be93-679292960758",
  //   "studentAcount": null,
  //   "studentCode": "2018011000",
  //   "studentName": "朱姬腾",
  //   "studentMobile": null,
  //   "studentSex": null,
  //   "studentBirth": null,
  //   "remark": null,
  //   "status": 0,
  //   "updateTime": null,
  //   "batchId": "14f9d302-a848-4167-9f4a-8a345191a2f9",
  //   "studentCollege": "203",
  //   "studentClass": "机械18-4班",
  //   "studentBed": "1",
  //   "studentIdcard": null,
  //   "studentEducation": null,
  //   "studentGraduateType": "本科生",
  //   "studentSpeciality": "04001",
  //   "studentGrade": "2018",
  //   "studentTutor": null,
  //   "studentInstructor": "2014880024",
  //   "studentStatus": "01",
  //   "studentRoom": "3401",
  //   "studentFloor": "4层",
  //   "studentBuilding": "3号楼",
  //   "studentArea": "润杰公寓",
  //   "studentGraduationTime": "20220628",
  //   "oldId": null
  // },
];

export default {
  name: "SubGranduationList",
  data() {
    return {
      uploadExcelRules,
      uploadFileUri,
      columns: columns,
      dataSource: dataSource,
      pagination: {
        pageSize: 10,
        showTotal: (total) => `共${total}条`,
        current: 1,
        total: 0,
        onChange: (current) => this.onPageChange(current),
      },
      loading: false,
      params: {
        name: undefined,
        batchId: this.$route.query.batchId,
        pageIndex: 1,
        pageSize: 10,
      },
      uploadFrom: {
        batchId: this.$route.query.batchId,
        filePath: undefined,
        fileName:undefined
      },
      uploadModal: false,
      uploadType: undefined,
      uploadLoading: false,
    };
  },
  methods: {
    handleChange(info) {
      if (info.file.status !== "uploading") {
        this.uploadLoading = true;
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.uploadLoading = false;
        let fileInfo = info.file.response.data;
        this.uploadFrom.fileName = info.file.name;
        this.uploadFrom.filePath = fileInfo.filePath;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败.`);
      }
    },
    uploadFileModal(type) {
      this.uploadType = type;
      this.uploadFrom.filePath = undefined;
      this.uploadFrom.fileName = undefined;
      this.uploadModal = true;
    },
    loadData() {
      this.loading = true;
      queryStudentByBatchId(this.params).then((res) => {
        console.log(res);
        this.dataSource = res.records;
        this.loading = false;
        this.pagination.current = res.current;
        this.pagination.total = res.total;
      });
    },
    onPageChange(page) {
      this.params.pageIndex = page;
      this.loadData();
    },
    search() {
      this.onPageChange(1);
    },
    async del(studentId) {
      await deleteStudent({ studentId });
      this.$message.success("删除成功");
      this.loadData();
    },
    async submit() {
      this.$refs.uploadExcelRuleForm.validate(async (valid) => {
        if (valid) {
          if (this.uploadType == "del") {
            let msgContent = await uploadDelStudent(this.uploadFrom);
            if(msgContent.msg) return this.$message.error(msgContent.msg)
          } else {
            let msgContent = await uploadSaveStudent(this.uploadFrom);
            if(msgContent.msg) return this.$message.error(msgContent.msg)
          }
          this.$message.success("操作成功");
          this.uploadModal = false;
          this.loadData();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    downloadTemplateFile() {
      downloadTemplateFile({
        type: "student",
        name: "graduationDel",
        fileName: "毕业名单",
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
.overlay {
  background: #fff;
  padding: 10px;
  border: 1px solid #eee;
}
</style>
